import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('TradeXRadar render failure', error, info);
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <main className="fatal-state">
          <div className="fatal-state__mark">TX</div>
          <h1>TradeXRadar needs a fresh start</h1>
          <p>An unexpected display error occurred. Your market data was not changed.</p>
          <button type="button" onClick={() => window.location.assign('/')}>
            Reopen dashboard
          </button>
        </main>
      );
    }
    return this.props.children;
  }
}
